import { Injectable } from '@angular/core';
import { DateQueryModel } from '@Common/Forms/models/date-query.model';
import { MonitoringSeriesTypeEnum } from '@Monitor/Shared/enums/monitoring-series-type.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MentionSearchSettingService {
    protected dateQuerySubject = new BehaviorSubject<DateQueryModel>(DateQueryModel.getAllQuery());
    dateQuery$ = this.dateQuerySubject.asObservable();

    protected selectTypeSubject = new BehaviorSubject<MonitoringSeriesTypeEnum>(MonitoringSeriesTypeEnum.folder);
    selectType$ = this.selectTypeSubject.asObservable();

    protected hasUnsavedSourceTypeSubject = new BehaviorSubject<boolean>(false);
    hasUnsavedSourceType$ = this.hasUnsavedSourceTypeSubject.asObservable();

    get currentDateQuery(): DateQueryModel {
        return this.dateQuerySubject.value;
    }

    updateDateQuery(dateQuery: DateQueryModel): void {
        this.dateQuerySubject.next(dateQuery);
    }

    updateSelectType(type: MonitoringSeriesTypeEnum): void {
        this.selectTypeSubject.next(type);
    }

    updateHasUnsavedSourceType(hasUnsavedSourceType: boolean): void {
        this.hasUnsavedSourceTypeSubject.next(hasUnsavedSourceType);
    }
}

